import { setUrlParams, equipmentType } from '@/utils/common'
import { request } from '@/utils/request'
import { useUserStore } from '@/store/modules/user'
import { useWxShareStore } from '@/store/modules/wxshare'
import Storage from '@/utils/Storage'
import { IOS_WX_ENTRY_URL } from '@/enums/cacheEnum'

export interface shareOpt {
  link?: string
  title: string
  shareTimelineTitleDesc?: string
  desc: string
  imgUrl: string
  shareTimelineCallback?: any
  cancel?: any
  success?: any
  fail?: any
  complete?: any
}

const locationOrigin = location.origin
const defaultShareImagePath = `${locationOrigin}/static/images/logo.jpg?v=${+new Date()}`
const WeixinJSBridge = (window as any).WeixinJSBridge
const isIOS = equipmentType() === 'ios'

/**
 * 微信自定义分享
 * @param {Json|Object} shareOpt - 微信分享配置 { [shareTimelineTitleDesc]: <分享朋友圈title> }
 */
export const wxConfig = async function (
  shareOpt?: shareOpt,
  _wxReadyCallback?: any
) {
  const userStore = useUserStore()
  const wxShareStore = useWxShareStore()
  let url = decodeURI(location.origin) // 分享默认链接: 首页
  const imgUrl = defaultShareImagePath
  let link = url
  const title = '中财捷企服'
  const default_options = {
    title: title,
    desc: '开公司上中财捷，经营老板的财税、企业、生活',
    imgUrl: encodeURI(imgUrl.trim()),
    success: function (res: any) {
      console.log('wxshare-common Success', res)
    },
    fail: function (err: any) {
      console.error('wxshare-common Failure', err)
    },
  }
  let options: shareOpt = {
    ...default_options,
  }

  // 自定义分享（非通用）
  if (shareOpt) {
    url = decodeURI(shareOpt.link || '')
    options = {
      title: shareOpt.title || '中财捷企服',
      desc: shareOpt.desc || '开公司上中财捷，经营老板的财税、企业、生活',
      imgUrl: !shareOpt.imgUrl ? imgUrl : encodeURI(shareOpt.imgUrl.trim()),
      success:
        shareOpt.success ||
        function (res: any) {
          console.log('wxshare-private Success', res)
          // SUCCESS
          console.log('自定义分享=success=>')
        },
      fail: function (res: any) {
        console.error('wxshare-private fail', res)
      },
    }
  }

  link = setUrlParams(url, 'v', '', { v: +new Date() })
  link = setUrlParams(url, 'shareToken', '', {
    shareToken: userStore.token,
  })
  options.link = link

  wx.error((res: any) => {
    wxShareStore.setIsWxConfigOk(false)
    try {
      throw new Error(
        `wx_error: ${JSON.stringify(
          res
        )}, signUrl: ${__url}, signData: ${JSON.stringify(
          res.data || {}
        )} options: ${JSON.stringify(options)}`
      )
    } catch {
      //
    }
  })

  function setWxConfig() {
    console.log('setWxConfig', options, location.href)
    // wx.updateTimelineShareData({
    //   ...options,
    //   title:
    //     shareOpt && shareOpt.shareTimelineTitleDesc
    //       ? shareOpt.shareTimelineTitleDesc
    //       : options.title,
    //   success: function () {
    //     shareOpt &&
    //       shareOpt.shareTimelineCallback &&
    //       shareOpt.shareTimelineCallback()
    //     callback && callback()
    //   },
    // })
    // wx.updateAppMessageShareData(options)
    wx.onMenuShareTimeline(options)
    wx.onMenuShareAppMessage(options)
    wx.onMenuShareQQ(options)
    wx.onMenuShareQZone(options)

    if (WeixinJSBridge) WeixinJSBridge.call('showOptionMenu')
    wx && wx.showOptionMenu()
  }

  // 需在用户可能点击分享按钮前就先调用
  wx.ready(function () {
    wxShareStore.setIsWxConfigOk(true)
    setWxConfig()
    _wxReadyCallback && _wxReadyCallback()
  })

  let __url = location.href
  if (isIOS) {
    const entryUrl = Storage.get(IOS_WX_ENTRY_URL)
    __url = encodeURIComponent(entryUrl)
    console.log('IOS entryUrl', __url)
  } else {
    __url = encodeURIComponent(location.href)
  }

  // IOS端微信分享仅需一次config设置
  if (wxShareStore.isWxConfigOk && isIOS) {
    setWxConfig()
    return false
  }

  // 微信分享 - 获取签名
  const resp: any = await request(
    {
      method: 'GET',
      url: `/wxoauth/getJsapiSignature?url=${__url}`,
    }
    // { isGetDataDirectly: true }
  ).catch((err) => {
    console.error('GET WX SIGN ERROR', err)
  })
  if (resp?.ret !== 100) return false
  setWxConfig()
  wx.config({
    ...resp.data,
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    // appId: opt.appId, // 必填，公众号的唯一标识
    // timestamp: opt.timestamp, // 必填，生成签名的时间戳
    // nonceStr: opt.nonceStr, // 必填，生成签名的随机串
    // signature: opt.signature,// 必填，签名
    jsApiList: [
      // 'updateAppMessageShareData',
      // 'updateTimelineShareData',
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareQZone',
      'hideOptionMenu',
      'showOptionMenu',
      'hideMenuItems',
    ], // 必填，需要使用的JS接口列表
  })

  if (WeixinJSBridge) {
    WeixinJSBridge.call('showOptionMenu')
  } else {
    if (wx) {
      wx.showOptionMenu()
    }
  }
}

export default wxConfig
